// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="height: 100%;">
    <observations-panel-root-toolbar></observations-panel-root-toolbar>
    <div class="scroll-container">
      <v-container v-if="$store.state.noctuaSky.status !== 'loggedIn'" fluid style="height: 100%">
        <h3 class="text-h5 mb-4">Observation Log Book</h3>
        <p>Every amateur astronomer will tell you: it is very rewarding to record your observations in an astronomical log book.<p>
        <p>You can use it to prepare your next observing session, or simply look back on your observing achievements, and share them with your friends !</p>
        <v-card style="margin-top: 80px;">
          <v-card-text class="white--text">
            <h3 class="text-h6 mb-3">Use NoctuaSky to</h3>
            <p>
              <ul>
                <li>Record and browse your observations</li>
                <li>Simulate your instruments</li>
                <li>More feature coming soon (sharing, downloading your data, etc..)</li>
              </ul>
            </p>
            <p>You need to be signed in to use these features</p>
            <v-row justify="space-around">
              <v-btn color="green" to="/p/users/signin">Sign In</v-btn> <v-btn to="/p/users/signup">Create an account</v-btn>
            </v-row>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-container>
      <v-container v-else fluid style="height: 100%">
        <grouped-observations v-for="obsg in observationGroups" :key="obsg.f1[0].id" :obsGroupData="obsg" @thumbClicked="thumbClicked"></grouped-observations>
        <div v-if="showEmptyMessage" style="margin-top: 30vh; text-align: center;">
          <v-row style="background: rgba(66, 66, 66, 0.3); padding: 25px;">
            <span>Select an object in the sky then click on <v-btn color="green" fab small dark style="transform: scale(0.5); margin: 0;"><v-icon>mdi-plus</v-icon></v-btn> to add a new observation in your astronomy log book</span>
          </v-row>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import ObservationsPanelRootToolbar from './observations-panel-root-toolbar.vue'
import GroupedObservations from './grouped-observations.vue'
import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      observationGroups: []
    }
  },
  methods: {
    thumbClicked: function (obs) {
      this.$router.push('/p/observations/' + obs.id)
    },
    refreshObservationGroups: function () {
      const that = this
      var aggregator = [
        { $group: { id: { location: '$location', julian_day: { $floor: '$time' } }, groupDate: { min: { $min: '$time' }, max: { $max: '$time' } }, f0: { $sum: 1 }, f1: { $push: '$$ROOT' } } },
        { $sort: { 'groupDate.max': -1 } }
      ]
      if (this.$store.state.selectedObject) {
        const obs = {
          target: this.$store.state.selectedObject,
          time: this.$store.state.stel.observer.utc,
          location: 'current',
          difficulty: 0,
          rating: 0,
          comment: '',
          observing_setup: {
            id: 'eyes_observation',
            state: {}
          },
          id: 'pseudo_obs_selection'
        }
        const lastModified = NoctuaSkyClient.observations.lastModified()
        if (lastModified) {
          obs.observing_setup = lastModified.observing_setup
        }
        const nearby = NoctuaSkyClient.locations.findNearby(this.$store.state.currentLocation.lat, this.$store.state.currentLocation.lng, 500)
        if (nearby) {
          obs.location = nearby.id
        }
        that.observationGroups = NoctuaSkyClient.observations.aggregate(aggregator, [obs])
        return
      }
      that.observationGroups = NoctuaSkyClient.observations.aggregate(aggregator)
    }
  },
  watch: {
    '$store.state.selectedObject': function () {
      this.refreshObservationGroups()
    },
    '$store.state.noctuaSky.observations': function () {
      this.refreshObservationGroups()
    }
  },
  computed: {
    showEmptyMessage: function () {
      return this.observationGroups.length === 0
    }
  },
  mounted: function () {
    this.refreshObservationGroups()
  },
  components: { GroupedObservations, ObservationsPanelRootToolbar }
}
</script>

<style>
.scroll-container {
  height: calc(100% - 48px);
  overflow-y: auto;
  backface-visibility: hidden;
}
ul {
  padding-left: 30px;
}
</style>
